export const AmenityBookingDurations = [15, 30, 60, 120];
export const AmenityBookingDurationsTimeSpan = ['00:15:00', '00:30:00', '01:00:00', '02:00:00'];